import { render, staticRenderFns } from "./ProductAccessoryList.vue?vue&type=template&id=a84592a6&scoped=true&"
import script from "./ProductAccessoryList.ts?vue&type=script&lang=js&"
export * from "./ProductAccessoryList.ts?vue&type=script&lang=js&"
import style0 from "./ProductAccessoryList.vue?vue&type=style&index=0&id=a84592a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84592a6",
  null
  
)

export default component.exports